export enum CategorySearchType {
  CATEGORY_NAME = "name",
  DESCRIPTION = "description",
}
